import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import Button from "../components/Button";
import { sfmaBoard } from "../data/board";
import { festival } from "../data/festival";
import { useTickets } from "../context/TicketsContext";
import styles from "./Sfma.module.css";

const aboutSubNav = [
  { label: "About", path: "/about", end: true },
  { label: "Venue Info", path: "/about/venue" },
  { label: "FAQ", path: "/about/faq" },
  { label: "SFMA", path: "/about/sfma" },
  { label: "Press", path: "/about/press" },
  { label: "Contact", path: "/about/contact" },
];

export default function Sfma() {
  const { open: openTickets } = useTickets();
  return (
    <>
      <PageHero
        eyebrow="South Fork Music Association"
        title="Keeping Music Alive — One Child at a Time"
        lede="A volunteer-run nonprofit putting instruments and free lessons into the hands of children across the San Luis Valley."
        image="/photos/sfma-donation.jpg"
      />
      <SubNav items={aboutSubNav} />

      <Page>
        <div className={styles.grid}>
          <div className={styles.body}>
            <p className={styles.lead}>
              The South Fork Music Association (SFMA) is a 501(c)(3) nonprofit
              dedicated to bringing music to children in rural Southern Colorado —
              kids whose schools and families often can't afford instruments, sheet
              music, or private lessons.
            </p>
            <p>
              Through ticket sales, sponsor partnerships, and grants, SFMA has
              distributed thousands of dollars in stringed instruments, materials,
              and one-on-one instruction across the San Luis Valley. The organization
              also stages family-friendly concerts, hosts student recitals, and
              channels music dollars into the regional economy.
            </p>
            <h3 className={styles.h3}>What SFMA Funds</h3>
            <ul className={styles.list}>
              <li>Stringed instruments placed in the hands of valley children</li>
              <li>Free lessons, paid for participating instructors</li>
              <li>Performance venues for student recitals</li>
              <li>Workshop scholarships and program materials</li>
              <li>Family-friendly community concerts</li>
            </ul>
            <p className={styles.cta}>
              <Button onClick={openTickets} variant="primary">
                Buy a Ticket — Fund a Lesson
              </Button>
              <Button href={`mailto:${festival.email}`} variant="outline">
                Donate or Partner
              </Button>
            </p>
          </div>
          <aside className={styles.board}>
            <h3 className={styles.boardTitle}>Board of Directors</h3>
            <ul className={styles.boardList}>
              {sfmaBoard.map((m) => (
                <li key={m.name}>
                  <strong>{m.name}</strong>
                  <span>{m.role}</span>
                </li>
              ))}
            </ul>
            <div className={styles.mailing}>
              <h4>Mailing</h4>
              <p>{festival.mailing}</p>
              <p><a href={`mailto:${festival.email}`}>{festival.email}</a></p>
            </div>
          </aside>
        </div>
      </Page>
    </>
  );
}
